import type { IntlService } from 'ember-intl';

export type TDirections = 'next' | 'last';
export type TPeriods = 'days' | 'weeks' | 'months' | 'years';
const Directions: Record<TDirections, string> = {
  next: 'next',
  last: 'last'
};
const Periods: Record<TPeriods, string> = {
  days: 'days',
  weeks: 'weeks',
  months: 'months',
  years: 'years'
};

export const DirectionsOptions = (intl: IntlService) =>
  Object.keys(Directions).map((key: string) => {
    return { key, label: intl.t(Directions[key as TDirections]) };
  });

export const PeriodsOptions = (intl: IntlService) => {
  return (Object.keys(Periods) as TPeriods[]).map((key: TPeriods) => {
    return { key, label: intl.t(Periods[key]), abv: intl.t(Periods[key])[0] };
  });
};

export type TDirectionOption = { key: TDirections; label: string };
export type TPeriodOption = { key: TPeriods; label: string; abv: string };
export const DynamicDatePrefix = 'date_';
export const DynamicCurrentDate = 'date_currentDate';
